





















import Vue from "vue";
import {Component} from "vue-property-decorator";
import {RouteNames} from "@/router/types";
import {Getter} from "vuex-class";
import {StoreNamespace} from "@/store/types";
import {ITournamentEntity} from "@/core/tournaments/tournament.entity";
import {Timing} from "@/core/helpers/Timing";
import CircularLoading from "@/components/Loading/CircularLoading.vue";
import TournamentListCard from "@/components/Tournaments/TournamentListItem/TournamentListCard.vue";
import {Moment} from "moment";
import {VuexState} from "@/core/vuex/types";
import {UserProfileStoreModule} from "@/store";
import {TournamentTypes} from "@/core/tournaments/types";
import Pagination from "@/components/Shared/Pagination.vue";
import {IPagination} from "@/core/service/types";
import {UserProfileModuleGetterTypes} from "@/store/modules/userProfile/types";

@Component({
  components: {Pagination, TournamentListCard, CircularLoading},
  enums: {
    RouteNames,
    VuexState
  }
})
export default class AvailableTournamentsPage extends Vue {
  @Getter(UserProfileModuleGetterTypes.ACCOUNT_TOURNAMENTS, { namespace: StoreNamespace.UserProfile })
  private readonly tournaments!: ITournamentEntity[]

  @Getter(UserProfileModuleGetterTypes.ACCOUNT_TOURNAMENTS_VUEX_STATE, { namespace: StoreNamespace.UserProfile })
  private readonly currentState!: boolean

  @Getter(UserProfileModuleGetterTypes.ACCOUNT_TOURNAMENTS_PAGINATION, { namespace: StoreNamespace.UserProfile })
  private readonly pagination!: IPagination

  private interval: NodeJS.Timeout | null = null
  private dateTimeNow: Moment = Timing.getTimeNow()

  private async created () {
    this.startTimer()
  }

  private startTimer () {
    this.interval = setInterval(() => {
      this.dateTimeNow = Timing.getTimeNow()
    }, 1000)
  }

  private stopTimer () {
    if (this.interval != null) {
      clearInterval(this.interval)
      this.interval = null
    }
  }

  private beforeDestroy () {
    this.stopTimer()
  }

  private onCurrentPageChange (newCurrentPage: number) {
    UserProfileStoreModule.onCurrentPaginationPageChange({
      dataType: TournamentTypes.Current,
      newCurrentPage: newCurrentPage
    })
  }
}
